<template>
  <div class="app-content ap history">
    <div class="row mb-4">
      <div class="col">
        <div class="d-flex h-100 w-100 align-items-center">
          <h1 class="ap__main-title">Folder <strong>{{ getFolderName() }}</strong> History</h1>
        </div>
      </div>
      <div class="col-auto">
        <router-link to="/dashboard" class="btn btn-primary">Back to Dashboard</router-link>
      </div>
    </div>
    <div class="content-block">
      <div class="content-block__body">
        <table class="table history__table" v-if="folderHistory.length">
          <thead>
            <tr>
              <th>Date</th>
              <th>User</th>
              <th>Object</th>
              <th>Name</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(action, index) in folderHistory" :key="index">
              <th>{{ action.date | moment("YYYY-MM-DD HH:mm:ss") }}</th>
              <th>{{ action.user }}</th>
              <th>{{ action.obj }}</th>
              <th>{{ action.obj_descr }}</th>
              <th>{{ action.action }}</th>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "@/common/api.service";
import { mapGetters } from "vuex";
export default {
  name: "History",
  data() {
    return {
      folderId: null,
      folderHistory: []
    }
  },
  computed: {
    ...mapGetters(["isAuthenticated", "folders"])
  },
  methods: {
    getFolderName() {
      for (var i = this.folders.length - 1; i >= 0; i--) {
        if(this.folders[i].folder_id == this.folderId) {
          return this.folders[i].folder_title;
        }
      }
    },
    getFolderHistory() {
      ApiService.setHeader();
      ApiService.get("history/" + this.folderId + "/")
      .then((response) => {
        this.folderHistory = response.data;
      });
    }
  },
  mounted() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "login" });
      return;
    }

    this.folderId = this.$route.params.id;

    this.getFolderHistory();
  }
}
</script>

<style lang="scss">

.history {

  &__table.table {
    font-size: rem(14px);
    color: $color-abbey;
    font-weight: 400;
    margin-bottom: 0;

    tbody {
      font-family: $font-family-roboto;
    }
  }
}

</style>